import * as React from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import NotificationsStore, { NotificationEntity } from '../../../Stores/NotificationsStore'
import HttpActionsService from '../../../Services/HttpActionsService'
import ExternalDataStore from '../../../Stores/ExternalDataStore'
import LocalizationStore from '../../../Stores/LocalizationStore'
// import ExternalCheckGovDataForm from '../../PartialViews/ExternalData/ExternalDataViews/ExternalCheckGovDataForm'
import QuestionnairesStore from '../../../Stores/QuestionnairesStore'
import { Link } from 'react-router-dom'
import ExternalDataCreditInfoItemsView
    from '../../PartialViews/ExternalData/ExternalDataViews/ExternalDataCreditInfoItemsView'

export interface IExternalCheckPageProps {
    localizationStore?: LocalizationStore
    httpActionsService?: HttpActionsService
    externalDataStore?: ExternalDataStore
    notificationsStore?: NotificationsStore
    questionnairesStore?: QuestionnairesStore
}

@inject('localizationStore')
@inject('httpActionsService')
@inject('externalDataStore')
@inject('notificationsStore')
@inject('questionnairesStore')
@observer
class ExternalCheckPage extends React.Component<IExternalCheckPageProps> {
    constructor(props: any) {
        super(props)
    }

    componentDidMount() {
        if (this.props['match']!['params']['questionnaireId']) {
            this.props.httpActionsService!
                .getExternalDataByQuestionnaireId(this.props['match']!['params']['questionnaireId'])
        } else {
            this.props.notificationsStore!
                .addAlert(
                    new NotificationEntity(
                        'danger',
                        this.props.localizationStore!.t('no questionnaireId in query params!')
                    )
                )
        }
    }

    render() {
        const { externalDataStore, questionnairesStore, localizationStore } = this.props

        let q = questionnairesStore!.getItem

        if (!q) {
            return localizationStore!.t!('no data')
        }

        if (externalDataStore!.isError) {
            return (<div>{this.props.localizationStore!.t('No data text')}</div>)
        }

        return (
            <div className="externalCheckPage row">
                <div className="col-12">
                    <Link
                        className="qDetailLink"
                        to={'/questionnaire/' + q.id}
                    >
                        {localizationStore!.t!('Back to Questionnaire')}
                    </Link>
                </div>
                <div className="col-12">
                    {!!externalDataStore!
                        .getData && externalDataStore!.getData!.creditInfoItems.length
                        ? <ExternalDataCreditInfoItemsView
                            headerText={localizationStore!.t!('Get external data by phone')}
                            creditInfoItems={externalDataStore!.getData!.creditInfoItems}
                        />
                        : <div>
                            <p>{localizationStore!.t('No data text')}</p>
                        </div>}
                </div>

                {/* <div className="col-12">
                    <ExternalCheckGovDataForm questionnaire={q} />
                </div> */}
            </div>
        )
    }
}

export default withRouter(ExternalCheckPage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/ExternalDataPages/ExternalCheckPage.tsx